export enum SortOrder {
  Ascending = 'asc',
  Descending = 'desc'
}

/**
 * Sorting information.
 */
export default class Sort {
  field: string;
  asc: boolean;

  constructor(deriveFrom?: Partial<Sort>) {
    if (!deriveFrom) {
      return;
    }

    Object.assign(this, deriveFrom);
  }

  toQuery() {
    return {
      sortBy: this.field || null,
      sortOrder: typeof this.asc == 'boolean' ? (this.asc ? 'asc' : 'desc') : null,
    }
  }
}